// 获取一组数据中最大数向上取整后的合适刻度值
export function getMaxIntFromNumbers(list) {
  const max = Math.max.apply(null, list);
  const int = parseInt(max, 10);
  const len = int.toString().length;
  const times = parseInt(1 + new Array(len).join('0'), 10);
  return Math.ceil(int / times) * times;

  // if (max <= 0) return 1;
  // // 计算数量级（支持小数）
  // const magnitude = Math.pow(10, Math.floor(Math.log10(max)));
  // return Math.ceil(max / magnitude) * magnitude;
}
